<div [formGroup]="formGroup">
  <div [formArrayName]="propValuesFormArrayKey">
    @for (langName of languagePropsFormArray.controls; track langName; let index = $index) {
      <div [formGroupName]="index" class="flex-form-grid__row">
        <mat-form-field class="flex-form-grid__row__item">
          <mat-label>{{'Language' | translate}}</mat-label>
          <mat-select formControlName="language" name="language" id="language-{{index}}" placeholder="Select Language" class="form-control">
            @for (lang of languages; track lang) {
              <mat-option [value]="lang" [disabled]="isLanguageAddedAlready(lang.code)">
                {{ lang.name | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-form-grid__row__item">
          <mat-label>{{propName | titlecase | translate}}</mat-label>
          <input [formControlName]="propName" [name]="propName" id="propName-{{index}}" matInput type="text" class="form-control">
        </mat-form-field>
        <div fxLayout="row" class="edit-dialog__categories__actions">
          @if (index === languagePropsFormArray.controls.length - 1 && canAddLanguageProps()) {
            <button mat-icon-button (click)="onAddLanguageRow()" type="button">
              <mat-icon>add</mat-icon>
            </button>
          }
          @if (index > 0) {
            <button mat-icon-button (click)="onRemoveLanguageRow(index)" type="button">
              <mat-icon>remove</mat-icon>
            </button>
          }
          @if (index === 0 && !canAddLanguageProps()) {
            <button mat-icon-button type="button">
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
